import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    const res = await register(form.email, form.password, form.name);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome to the movement.");
      navigate(next);
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="grain min-h-screen flex items-center justify-center px-6 py-20" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="text-center">
          <div className="label-eyebrow">Founding Membership</div>
          <h1 className="mt-4 font-serif text-5xl text-bdu-cream tracking-tight">Join The Fund</h1>
          <p className="mt-3 text-bdu-cream/60">Create your account. Become a stakeholder.</p>
        </div>

        <form onSubmit={onSubmit} className="mt-10 bdu-card p-8 space-y-5">
          <div>
            <div className="label-eyebrow mb-3">Full Name</div>
            <input required value={form.name} onChange={update("name")}
              className="w-full bg-transparent border border-bdu-gold/25 px-4 py-3 text-bdu-cream outline-none focus:border-bdu-gold"
              data-testid="register-name-input" />
          </div>
          <div>
            <div className="label-eyebrow mb-3">Email</div>
            <input required type="email" value={form.email} onChange={update("email")}
              className="w-full bg-transparent border border-bdu-gold/25 px-4 py-3 text-bdu-cream outline-none focus:border-bdu-gold"
              data-testid="register-email-input" />
          </div>
          <div>
            <div className="label-eyebrow mb-3">Password</div>
            <input required type="password" minLength={6} value={form.password} onChange={update("password")}
              className="w-full bg-transparent border border-bdu-gold/25 px-4 py-3 text-bdu-cream outline-none focus:border-bdu-gold"
              data-testid="register-password-input" />
            <p className="mt-2 text-xs text-bdu-cream/40">Minimum 6 characters</p>
          </div>
          <button type="submit" disabled={loading} className="btn-gold w-full justify-center" data-testid="register-submit-btn">
            {loading ? "Creating account..." : "Create Account"}
          </button>
        </form>

        <p className="mt-8 text-center text-sm text-bdu-cream/60">
          Already a member?{" "}
          <Link to={`/login${next ? `?next=${next}` : ""}`} className="text-bdu-gold hover:underline" data-testid="register-to-login-link">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
